import React from 'react';
import { Box, TextField, Typography, Grid } from '@mui/material';

export const Gauge = ({ value = {}, onChange, editMode = false }) => {
  if (editMode) {
    return (
      <Box my={2}>
        <Typography variant="h6" gutterBottom>Gauge</Typography>
        <Grid container spacing={1}>
          <Grid size={12}>
            <TextField
              label="Stitch Name"
              value={value.stitchName || ''}
              onChange={(e) => onChange('gauge', { ...value, stitchName: e.target.value })}
              fullWidth
              margin="dense"
              size="small"
            />
          </Grid>
          <Grid size={4}>
          <TextField
              label="Stitches"
              type="number"
              value={value.stitches ?? ''}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                const numValue = e.target.value === '' ? '' : Number(e.target.value);
                onChange('gauge', { ...value, stitches: numValue });
              }}
              fullWidth
              margin="dense"
              size="small"
            />
          </Grid>
          <Grid size={4}>
            <TextField
              label="Rows"
              type="number"
              value={value.rows ?? ''}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => {
                const numValue = e.target.value === '' ? '' : Number(e.target.value);
                onChange('gauge', { ...value, rows: numValue });
              }}
              fullWidth
              margin="dense"
              size="small"
            />
          </Grid>
          <Grid size={8}>
            <TextField
              label="Needle Size"
              value={value.needleSize || ''}
              onChange={(e) => onChange('gauge', { ...value, needleSize: e.target.value })}
              fullWidth
              margin="dense"
              size="small"
            />
          </Grid>
        </Grid>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          {value.stitches && value.rows ? 
            `Gauge: In ${value.stitchName}, ${value.stitches} stitches and ${value.rows} rows = 4" (10cm)` :
            'Enter your gauge measurements to see them here'}
        </Typography>
      </Box>
    );
  }

  if (!value.stitches || !value.rows) return null;

  return (
    <Box my={2}>
      <Typography variant="h6" gutterBottom>Gauge</Typography>
      <Typography>
        {value.stitchName && `In ${value.stitchName}, `}
        {value.stitches} sts & {value.rows} rows = 4"/10cm
        {value.needleSize && ` on ${value.needleSize} needles`}
        . To save time, take time to check gauge.
      </Typography>
    </Box>
  );
};

export default Gauge;
